import { BsEye } from 'react-icons/bs';
import DocumentLinesModal from '../../components/documents/DocumentLinesModal';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { apiFetch, parseJsonSafe } from '../../utils/api';
import {
  BsEnvelope, BsWhatsapp, BsTelephone, BsChatLeftText,
  BsPersonVcard, BsPeople, BsJournalText, BsRobot,
  BsPaperclip, BsKanban, BsListCheck,
  BsFileEarmarkText, BsReceipt, BsArrowRepeat, BsClockHistory,
  BsGlobe2, BsHddNetwork, BsBoxSeam
} from 'react-icons/bs';
import './ClientDetailPage.css';
import EmailBody from '../../components/EmailBody';
import ClientWhatsappTab from '../../components/clients/ClientWhatsappTab';
import ClientTimePacksTab from '../../components/clients/ClientTimePacksTab';
import ClientServicesTab from '../../components/clients/ClientServicesTab';
import BudgetActionsMenu from '../../components/budgets/BudgetActionsMenu';
import ProjectCreateModal from '../../components/projects/ProjectCreateModal';
import { getLocalDateTimeValue } from '../../utils/dateUtils';
import { formatCurrency, formatDate, formatRecurrence, previewFile } from '../../utils/invoiceUtils';

const TAB_GROUPS = [
  { label: 'General', items: [
    { name: 'Ficha', Icon: BsPersonVcard },
    { name: 'Contactos', Icon: BsPeople },
    { name: 'Notas', Icon: BsJournalText },
    { name: 'Perfil IA', Icon: BsRobot }
  ] },
  { label: 'Actividad', items: [
    { name: 'Comunicaciones', Icon: BsEnvelope },
    { name: 'WhatsApp', Icon: BsWhatsapp },
    { name: 'Adjuntos', Icon: BsPaperclip }
  ] },
  { label: 'Trabajo', items: [
    { name: 'Proyectos', Icon: BsKanban },
    { name: 'Tareas', Icon: BsListCheck }
  ] },
  { label: 'Comercial', items: [
    { name: 'Presupuestos', Icon: BsFileEarmarkText },
    { name: 'Facturas', Icon: BsReceipt },
    { name: 'Facturas recurrentes', Icon: BsArrowRepeat },
    { name: 'Servicios', Icon: BsBoxSeam },
    { name: 'Bolsas de horas', Icon: BsClockHistory }
  ] },
  { label: 'Infraestructura', items: [
    { name: 'Dominios', Icon: BsGlobe2 },
    { name: 'Hosting', Icon: BsHddNetwork }
  ] }
];

// Notificaciones push: plantillas rápidas y destinos (deep link dentro de la app móvil)
const PUSH_TEMPLATES = [
  { label: 'Respuesta de soporte', title: 'Tienes respuesta de soporte', body: 'Tu ticket tiene una nueva respuesta. Entra para verla.', route: '/soporte' },
  { label: 'Factura lista', title: 'Tu factura está lista', body: 'Ya puedes consultar y descargar tu factura desde la app.', route: '/facturas' },
  { label: 'Presupuesto enviado', title: 'Tienes un presupuesto nuevo', body: 'Te hemos enviado un presupuesto. Puedes revisarlo en la app.', route: '/presupuestos' },
  { label: 'Proyecto actualizado', title: 'Actualización de tu proyecto', body: 'Hemos actualizado el estado de tu proyecto.', route: '/proyectos' },
];
const PUSH_ROUTES = [
  { value: '', label: 'No abrir nada en concreto' },
  { value: '/', label: 'Inicio' },
  { value: '/facturas', label: 'Facturas' },
  { value: '/presupuestos', label: 'Presupuestos' },
  { value: '/proyectos', label: 'Proyectos' },
  { value: '/horas', label: 'Bolsas de horas' },
  { value: '/servicios', label: 'Servicios' },
  { value: '/licencias', label: 'Licencias' },
  { value: '/infraestructura', label: 'Dominios y hosting' },
  { value: '/soporte', label: 'Soporte' },
  { value: '/perfil', label: 'Mi perfil' },
];

const ClientDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'Ficha';
  const setActiveTab = (t) => setSearchParams({ tab: t }, { replace: true });
  const [linesDocument, setLinesDocument] = useState(null);
  const invoiceOrigin = useLocation().state?.invoiceNavigation;
  const token = localStorage.getItem('token');
  const [client, setClient] = useState(null);
  const [tabCounts, setTabCounts] = useState({});
  const [contacts, setContacts] = useState([]);
  const [contactForm, setContactForm] = useState({ nombre: '', cargo: '', email: '', telefono: '' });
  const [editingContactId, setEditingContactId] = useState(null);
  const [notes, setNotes] = useState([]);
  const [noteForm, setNoteForm] = useState({ titulo: '', comentarios: '' });
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [loadingClient, setLoadingClient] = useState(true);
  const [pushModal, setPushModal] = useState(false);
  const [pushForm, setPushForm] = useState({ title: '', body: '', route: '' });
  const [pushBusy, setPushBusy] = useState(false);
  const [pushHistory, setPushHistory] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [loadingComms, setLoadingComms] = useState(false);
  const [error, setError] = useState('');
  const [contactError, setContactError] = useState('');
  const [noteError, setNoteError] = useState('');
  const [commsError, setCommsError] = useState('');
  const [communications, setCommunications] = useState([]);
  const [commsFilters, setCommsFilters] = useState({ canal: '', direccion: '', search: '' });
  const [commsPage, setCommsPage] = useState(1);
  const [commsTotal, setCommsTotal] = useState(0);
  const commsPageSize = 30;
  const [selectedComm, setSelectedComm] = useState(null);
  const [manualCommOpen, setManualCommOpen] = useState(false);
  const [manualCommSaving, setManualCommSaving] = useState(false);
  const [manualCommForm, setManualCommForm] = useState({
    canal: 'call',
    direccion: 'out',
    asunto: '',
    cuerpo_texto: '',
    fecha: ''
  });
  const [, setEmailAccounts] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [loadingEmailTemplates, setLoadingEmailTemplates] = useState(false);
  const [domains, setDomains] = useState([]);
  const [domainForm, setDomainForm] = useState({ id: null, dominio: '', fechaRegistro: '', fechaRenovacion: '' });
  const [hostings, setHostings] = useState([]);
  const [hostingForm, setHostingForm] = useState({
    id: null,
    hosting: '',
    caracteristicas: '',
    fechaAlta: '',
    fechaRenovacion: '',
    precio: ''
  });
  const [budgets, setBudgets] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [whatsappInvoiceModal, setWhatsappInvoiceModal] = useState({
    open: false,
    sending: false,
    error: '',
    invoiceId: null,
    phone: '',
    clientName: '',
    invoiceNumber: '',
    templateName: 'envio_factura'
  });
  // Plantillas de Meta que adjuntan documento (para enviar facturas). Se leen en vivo:
  // las plantillas nuevas aparecen solas, sin tocar el código.
  const [docTemplates, setDocTemplates] = useState([]);
  useEffect(() => {
    if (!whatsappInvoiceModal.open) return;
    (async () => {
      try {
        const res = await apiFetch('/api/whatsapp/templates?all=1', { headers: { Authorization: `Bearer ${token}` } });
        const data = await parseJsonSafe(res);
        if (Array.isArray(data)) setDocTemplates(data.filter((t) => t.type === 'waba' && t.mediaHeader === 'DOCUMENT'));
      } catch (_e) { /* se queda la plantilla por defecto */ }
    })();
  }, [whatsappInvoiceModal.open, token]);
  const [emailInvoiceModal, setEmailInvoiceModal] = useState({
    open: false,
    sending: false,
    error: '',
    invoiceId: null,
    to: '',
    subject: '',
    templateId: '',
    bodyHtml: '',
    invoiceNumber: ''
  });
  const [whatsappBudgetModal, setWhatsappBudgetModal] = useState({
    open: false,
    sending: false,
    error: '',
    budgetId: null,
    phone: '',
    clientName: '',
    budgetNumber: ''
  });
  const [whatsappAttachmentModal, setWhatsappAttachmentModal] = useState({
    open: false,
    sending: false,
    error: '',
    attachmentId: null,
    sourceType: null,
    phone: '',
    clientName: '',
    filename: ''
  });
  const [emailBudgetModal, setEmailBudgetModal] = useState({
    open: false,
    sending: false,
    error: '',
    budgetId: null,
    to: '',
    subject: '',
    templateId: '',
    bodyHtml: '',
    budgetNumber: ''
  });
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [syncingInvoices, setSyncingInvoices] = useState(false);
  const [budgetPage, setBudgetPage] = useState(1);
  const [invoicePage, setInvoicePage] = useState(1);
  const pageSize = 10;
  const [syncingBudgets, setSyncingBudgets] = useState(false);
  const [clientTasks, setClientTasks] = useState([]);
  const [clientProjects, setClientProjects] = useState([]);
  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [portalBusy, setPortalBusy] = useState(false);
  const [whatsappTpl, setWhatsappTpl] = useState('solicitud_recibida');
  const [whatsappTplSending, setWhatsappTplSending] = useState(false);
  const [whatsappTplError, setWhatsappTplError] = useState('');
  const [clientAttachments, setClientAttachments] = useState([]);
  const [clientAttachmentsLoading, setClientAttachmentsLoading] = useState(false);
  const [clientAttachmentsError, setClientAttachmentsError] = useState('');
  const [clientAttachmentFile, setClientAttachmentFile] = useState(null);
  const [clientAttachmentUploading, setClientAttachmentUploading] = useState(false);
  const [clientAttachmentInputKey, setClientAttachmentInputKey] = useState(0);
  const [clientProfile, setClientProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  const toggleInvoiceVisibility = async (inv) => {
    const current = inv.visible_cliente !== false;
    const next = !current;
    setInvoices((prev) => prev.map((it) => (it.id === inv.id ? { ...it, visible_cliente: next } : it)));
    try {
      const res = await apiFetch(`/api/clients/invoices/${inv.id}/visibility`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ visible_cliente: next })
      });
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) { const d = await parseJsonSafe(res); throw new Error((d && d.message) || 'No se pudo actualizar la visibilidad'); }
    } catch (err) {
      setInvoices((prev) => prev.map((it) => (it.id === inv.id ? { ...it, visible_cliente: current } : it)));
      alert(err.message);
    }
  };

  const toggleBudgetVisibility = async (b) => {
    const current = b.visible_cliente === true;
    const next = !current;
    setBudgets((prev) => prev.map((it) => (it.id === b.id ? { ...it, visible_cliente: next } : it)));
    try {
      const res = await apiFetch(`/api/clients/budgets/${b.id}/visibility`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ visible_cliente: next })
      });
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) { const d = await parseJsonSafe(res); throw new Error((d && d.message) || 'No se pudo actualizar la visibilidad'); }
    } catch (err) {
      setBudgets((prev) => prev.map((it) => (it.id === b.id ? { ...it, visible_cliente: current } : it)));
      alert(err.message);
    }
  };

  const buildWhatsappLink = (phone) => {
    const normalized = (phone || '').toString().replace(/\D/g, '');
    return normalized ? `/whatsapp?phone=${normalized}` : '';
  };

  const paginatedBudgets = useMemo(() => {
    const start = (budgetPage - 1) * pageSize;
    return budgets.slice(start, start + pageSize);
  }, [budgets, budgetPage]);

  const realInvoices = useMemo(() => invoices.filter((i) => !i.is_recurrent), [invoices]);
  const recurrentInvoices = useMemo(() => invoices.filter((i) => i.is_recurrent), [invoices]);

  const paginatedInvoices = useMemo(() => {
    const start = (invoicePage - 1) * pageSize;
    return realInvoices.slice(start, start + pageSize);
  }, [realInvoices, invoicePage]);

  const totalBudgetPages = Math.max(Math.ceil(budgets.length / pageSize), 1);
  const totalInvoicePages = Math.max(Math.ceil(realInvoices.length / pageSize), 1);

  const fetchClient = async () => {
    setLoadingClient(true);
    setError('');
    try {
      const res = await apiFetch(`/api/clients/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando cliente');
      setClient(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingClient(false);
    }
  };

  const syncBudgetsDolibarr = async () => {
    setSyncingBudgets(true);
    try {
      const res = await apiFetch(`/api/clients/${id}/budgets/sync`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error sincronizando');
      alert(`Sincronización completa. Importados: ${data.imported}/${data.total}`);
      fetchBudgets();
    } catch (err) {
      alert(err.message);
    } finally {
      setSyncingBudgets(false);
    }
  };

  const syncInvoicesDolibarr = async () => {
    setSyncingInvoices(true);
    try {
      const res = await apiFetch(`/api/clients/${id}/invoices/sync`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error sincronizando facturas');
      alert(`Sincronización completa. Importadas: ${data.imported}/${data.total}`);
      fetchInvoices();
    } catch (err) {
      alert(err.message);
    } finally {
      setSyncingInvoices(false);
    }
  };

  const fetchContacts = async () => {
    setLoadingContacts(true);
    setContactError('');
    try {
      const res = await apiFetch(`/api/clients/${id}/contacts`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando contactos');
      setContacts(data);
    } catch (err) {
      setContactError(err.message);
    } finally {
      setLoadingContacts(false);
    }
  };

  const fetchNotes = async () => {
    setLoadingNotes(true);
    setNoteError('');
    try {
      const res = await apiFetch(`/api/clients/${id}/notes`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando notas');
      setNotes(Array.isArray(data) ? data : []);
    } catch (err) {
      setNoteError(err.message);
    } finally {
      setLoadingNotes(false);
    }
  };

  useEffect(() => {
    fetchClient();
    fetchContacts();
    fetchNotes();
    fetchCommunications();
    fetchDomains();
    fetchHostings();
    fetchBudgets();
    fetchInvoices();
    fetchEmailAccounts();
    fetchEmailTemplates();
    fetchTasksClient();
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    fetchCommunications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commsFilters, commsPage]);

  useEffect(() => {
    if (activeTab !== 'Adjuntos') return;
    fetchClientAttachments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, id]);

  useEffect(() => {
    if (activeTab !== 'Perfil IA') return;
    const fetchProfile = async () => {
      setLoadingProfile(true);
      try {
        const res = await apiFetch(`/api/clients/${id}/knowledge-base`, { headers: { Authorization: `Bearer ${token}` } });
        if (res.ok) { setClientProfile(await res.json()); } else { setClientProfile(null); }
      } catch (_e) { setClientProfile(null); }
      setLoadingProfile(false);
    };
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, id]);

  // Contadores por pestaña (el "circulito" con el nº de elementos de cada tab).
  const fetchTabCounts = React.useCallback(async () => {
    try {
      const res = await apiFetch(`/api/clients/${id}/tab-counts`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) setTabCounts(await res.json());
    } catch (_e) { /* sin contadores */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  // Recalcula los contadores al montar (por id) y cada vez que cambia el tamaño de
  // cualquier lista de un tab -> toda alta/baja refresca los badges al instante.
  useEffect(() => { fetchTabCounts(); }, [
    fetchTabCounts, contacts.length, notes.length, budgets.length, invoices.length,
    domains.length, hostings.length, clientTasks.length, clientProjects.length,
    clientAttachments.length, commsTotal
  ]);

  const regenerateProfile = async () => {
    setLoadingProfile(true);
    try {
      const res = await apiFetch(`/api/clients/${id}/knowledge-base/regenerate`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      if (res.status === 401) return handleUnauthorized();
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error((data && data.message) || 'No se pudo regenerar el perfil');
      setClientProfile(data);
    } catch (err) { alert(err.message); }
    finally { setLoadingProfile(false); }
  };

  useEffect(() => {
    if (!emailTemplates.length) return;
    if (emailInvoiceModal.open && !emailInvoiceModal.templateId) {
      const tpl = emailTemplates[0];
      setEmailInvoiceModal((prev) => ({
        ...prev,
        templateId: String(tpl.id),
        bodyHtml: tpl.body_html || ''
      }));
    }
    if (emailBudgetModal.open && !emailBudgetModal.templateId) {
      const tpl = emailTemplates[0];
      setEmailBudgetModal((prev) => ({
        ...prev,
        templateId: String(tpl.id),
        bodyHtml: tpl.body_html || ''
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailTemplates]);

  const fetchCommunications = async () => {
    setLoadingComms(true);
    setCommsError('');
    try {
      const qs = new URLSearchParams();
      if (commsFilters.canal) qs.append('canal', commsFilters.canal);
      if (commsFilters.direccion) qs.append('direccion', commsFilters.direccion);
      if (commsFilters.search) qs.append('search', commsFilters.search);
      qs.append('page', commsPage.toString());
      qs.append('pageSize', commsPageSize.toString());
      const res = await apiFetch(`/api/clients/${id}/communications?${qs.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando comunicaciones');
      setCommunications(Array.isArray(data.items) ? data.items : Array.isArray(data) ? data : []);
      setCommsTotal(data.total || 0);
    } catch (err) {
      setCommsError(err.message);
    } finally {
      setLoadingComms(false);
    }
  };

  const openManualCommModal = () => {
    setManualCommForm({
      canal: 'call',
      direccion: 'out',
      asunto: '',
      cuerpo_texto: '',
      fecha: getLocalDateTimeValue()
    });
    setManualCommOpen(true);
  };

  const saveManualComm = async () => {
    if (!manualCommForm.cuerpo_texto.trim()) return alert('El contenido es obligatorio');
    setManualCommSaving(true);
    try {
      const res = await apiFetch(`/api/clients/${id}/communications`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          canal: manualCommForm.canal,
          direccion: manualCommForm.direccion,
          asunto: manualCommForm.asunto,
          cuerpo_texto: manualCommForm.cuerpo_texto,
          fecha: manualCommForm.fecha
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la comunicación');
      setManualCommOpen(false);
      setCommsPage(1);
      fetchCommunications();
    } catch (err) {
      alert(err.message);
    } finally {
      setManualCommSaving(false);
    }
  };

  const fetchProjects = async () => {
    try {
      const res = await apiFetch(`/api/projects?client_id=${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) {
        const items = data.items || data;
        setClientProjects(Array.isArray(items) ? items : []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDomains = async () => {
    try {
      const res = await apiFetch(`/api/clients/${id}/domains`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando dominios');
      setDomains(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchHostings = async () => {
    try {
      const res = await apiFetch(`/api/clients/${id}/hostings`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando hostings');
      setHostings(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBudgets = async () => {
    try {
      const res = await apiFetch(`/api/clients/${id}/budgets`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando presupuestos');
      setBudgets(Array.isArray(data) ? data : []);
      setBudgetPage(1);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchInvoices = async () => {
    setLoadingInvoices(true);
    try {
      const res = await apiFetch(`/api/clients/${id}/invoices`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'Error cargando facturas');
      setInvoices(Array.isArray(data) ? data : []);
      const currentIndex = Array.isArray(data) ? data.filter((item) => !item.is_recurrent).findIndex((item) => String(item.id) === String(invoiceOrigin?.currentId)) : -1;
      setInvoicePage(currentIndex >= 0 ? Math.floor(currentIndex / pageSize) + 1 : 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingInvoices(false);
    }
  };

  const previewPdf = async (endpoint) => {
    try { await previewFile(endpoint, token, handleUnauthorized); }
    catch (err) { alert(err.message); }
  };

  const downloadFile = async (endpoint, filename) => {
    try {
      const res = await apiFetch(endpoint, { headers: { Authorization: `Bearer ${token}` } });
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) {
        const data = await parseJsonSafe(res);
        throw new Error((data && data.message) || 'Error descargando archivo');
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'archivo.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert(err.message);
    }
  };

  const fetchTasksClient = async () => {
    try {
      const res = await apiFetch(`/api/tasks/client/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.ok && Array.isArray(data)) setClientTasks(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchClientAttachments = async () => {
    setClientAttachmentsLoading(true);
    setClientAttachmentsError('');
    try {
      const res = await apiFetch(`/api/clients/${id}/attachments`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando adjuntos');
      setClientAttachments(Array.isArray(data) ? data : []);
    } catch (err) {
      setClientAttachments([]);
      setClientAttachmentsError(err.message);
    } finally {
      setClientAttachmentsLoading(false);
    }
  };

  const uploadClientAttachment = async () => {
    if (!clientAttachmentFile) return;
    setClientAttachmentUploading(true);
    setClientAttachmentsError('');
    try {
      const fd = new FormData();
      fd.append('file', clientAttachmentFile);
      const res = await apiFetch(`/api/clients/${id}/attachments`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: fd
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo subir el adjunto');
      setClientAttachmentFile(null);
      setClientAttachmentInputKey((k) => k + 1);
      await fetchClientAttachments();
    } catch (err) {
      setClientAttachmentsError(err.message);
    } finally {
      setClientAttachmentUploading(false);
    }
  };

  const deleteClientAttachment = async (attachmentId) => {
    if (!window.confirm('¿Eliminar este adjunto?')) return;
    try {
      const res = await apiFetch(`/api/clients/client-attachments/${attachmentId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo eliminar el adjunto');
      fetchClientAttachments();
    } catch (err) {
      alert(err.message);
    }
  };

  const fetchEmailAccounts = async () => {
    try {
      const res = await apiFetch('/api/email-accounts', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.ok && Array.isArray(data)) setEmailAccounts(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchEmailTemplates = async () => {
    setLoadingEmailTemplates(true);
    try {
      const res = await apiFetch('/api/email/templates', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.ok && Array.isArray(data)) setEmailTemplates(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingEmailTemplates(false);
    }
  };

  const handleCreateContact = async (e) => {
    e.preventDefault();
    setContactError('');
    const isEdit = Boolean(editingContactId);
    const url = isEdit ? `/api/clients/${id}/contacts/${editingContactId}` : `/api/clients/${id}/contacts`;
    const method = isEdit ? 'PUT' : 'POST';
    try {
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(contactForm)
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar el contacto');
      setContactForm({ nombre: '', cargo: '', email: '', telefono: '' });
      setEditingContactId(null);
      fetchContacts();
    } catch (err) {
      setContactError(err.message);
    }
  };

  const handleDeleteContact = async (contactId) => {
    if (!window.confirm('¿Eliminar este contacto?')) return;
    try {
      const res = await apiFetch(`/api/clients/${id}/contacts/${contactId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo eliminar el contacto');
      fetchContacts();
    } catch (err) {
      alert(err.message);
    }
  };

  const startEditContact = (contact) => {
    setEditingContactId(contact.id);
    setContactForm({
      nombre: contact.nombre || '',
      cargo: contact.cargo || '',
      email: contact.email || '',
      telefono: contact.telefono || ''
    });
    setContactError('');
  };

  const handleSaveNote = async (e) => {
    e.preventDefault();
    setNoteError('');
    const isEdit = Boolean(editingNoteId);
    const url = isEdit ? `/api/clients/notes/${editingNoteId}` : `/api/clients/${id}/notes`;
    const method = isEdit ? 'PUT' : 'POST';
    try {
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(noteForm)
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la nota');
      setNoteForm({ titulo: '', comentarios: '' });
      setEditingNoteId(null);
      fetchNotes();
    } catch (err) {
      setNoteError(err.message);
    }
  };

  const startEditNote = (note) => {
    setEditingNoteId(note.id);
    setNoteForm({
      titulo: note.titulo || '',
      comentarios: note.comentarios || ''
    });
    setNoteError('');
  };

  const handleDeleteNote = async (noteId) => {
    if (!window.confirm('¿Eliminar esta nota?')) return;
    try {
      const res = await apiFetch(`/api/clients/notes/${noteId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo eliminar la nota');
      fetchNotes();
    } catch (err) {
      alert(err.message);
    }
  };

  const submitDomain = async (e) => {
    e.preventDefault();
    const isEdit = Boolean(domainForm.id);
    const path = isEdit ? `/api/clients/domains/${domainForm.id}` : `/api/clients/${id}/domains`;
    const method = isEdit ? 'PUT' : 'POST';
    const payload = {
      dominio: domainForm.dominio,
      fechaRegistro: domainForm.fechaRegistro || null,
      fechaRenovacion: domainForm.fechaRenovacion || null
    };
    const res = await apiFetch(path, {
      method,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload)
    });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error guardando dominio');
      return;
    }
    setDomainForm({ id: null, dominio: '', fechaRegistro: '', fechaRenovacion: '' });
    fetchDomains();
  };

  const editDomain = (dom) => {
    setDomainForm({
      id: dom.id,
      dominio: dom.dominio,
      fechaRegistro: dom.fecha_registro ? dom.fecha_registro.substring(0, 10) : '',
      fechaRenovacion: dom.fecha_renovacion ? dom.fecha_renovacion.substring(0, 10) : ''
    });
  };

  const deleteDomain = async (domainId) => {
    if (!window.confirm('¿Eliminar este dominio?')) return;
    const res = await apiFetch(`/api/clients/domains/${domainId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error eliminando dominio');
      return;
    }
    fetchDomains();
  };

  const submitHosting = async (e) => {
    e.preventDefault();
    const isEdit = Boolean(hostingForm.id);
    const path = isEdit ? `/api/clients/hostings/${hostingForm.id}` : `/api/clients/${id}/hostings`;
    const method = isEdit ? 'PUT' : 'POST';
    const payload = {
      hosting: hostingForm.hosting,
      caracteristicas: hostingForm.caracteristicas || null,
      fechaAlta: hostingForm.fechaAlta || null,
      fechaRenovacion: hostingForm.fechaRenovacion || null,
      precio: hostingForm.precio || null
    };
    const res = await apiFetch(path, {
      method,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload)
    });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error guardando hosting');
      return;
    }
    setHostingForm({ id: null, hosting: '', caracteristicas: '', fechaAlta: '', fechaRenovacion: '', precio: '' });
    fetchHostings();
  };

  const editHosting = (h) => {
    setHostingForm({
      id: h.id,
      hosting: h.hosting,
      caracteristicas: h.caracteristicas || '',
      fechaAlta: h.fecha_alta ? h.fecha_alta.substring(0, 10) : '',
      fechaRenovacion: h.fecha_renovacion ? h.fecha_renovacion.substring(0, 10) : '',
      precio: h.precio || ''
    });
  };

  const deleteHosting = async (hostingId) => {
    if (!window.confirm('¿Eliminar este hosting?')) return;
    const res = await apiFetch(`/api/clients/hostings/${hostingId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error eliminando hosting');
      return;
    }
    fetchHostings();
  };

  const deleteBudget = async (budgetId) => {
    if (!window.confirm('¿Eliminar este presupuesto?')) return;
    const res = await apiFetch(`/api/clients/budgets/${budgetId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error eliminando presupuesto');
      return;
    }
    fetchBudgets();
  };

  const deleteInvoice = async (invoiceId) => {
    if (!window.confirm('¿Eliminar esta factura?')) return;
    const res = await apiFetch(`/api/clients/invoices/${invoiceId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    const data = await parseJsonSafe(res);
    if (!res.ok) {
      alert(data.message || 'Error eliminando factura');
      return;
    }
    fetchInvoices();
  };

  const facturarProforma = async (invoiceId) => {
    if (!window.confirm('¿Crear factura normal desde esta proforma?')) return;
    try {
      const res = await apiFetch(`/api/clients/invoices/${invoiceId}/facturar`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error facturando proforma');
      alert(`Factura creada: ${data.numero || ''}`);
      fetchInvoices();
    } catch (err) {
      alert(err.message);
    }
  };

  const openWhatsappInvoiceModal = (invoice) => {
    const baseNumber = invoice?.numero ? invoice.numero : `#${invoice?.id || ''}`;
    setWhatsappInvoiceModal({
      open: true,
      sending: false,
      error: '',
      invoiceId: invoice?.id || null,
      phone: client?.telefono || '',
      clientName: client?.razon_social || '',
      invoiceNumber: baseNumber,
      templateName: 'envio_factura'
    });
  };

  const openWhatsappBudgetModal = (budget) => {
    const baseNumber = budget?.presupuesto ? budget.presupuesto : `#${budget?.id || ''}`;
    setWhatsappBudgetModal({
      open: true,
      sending: false,
      error: '',
      budgetId: budget?.id || null,
      phone: client?.telefono || '',
      clientName: client?.razon_social || '',
      budgetNumber: baseNumber
    });
  };

  const openEmailInvoiceModal = (invoice) => {
    const baseNumber = invoice?.numero ? invoice.numero : `#${invoice?.id || ''}`;
    const defaultTemplateId = emailTemplates[0]?.id ? String(emailTemplates[0].id) : '';
    const template = emailTemplates.find((t) => String(t.id) === defaultTemplateId);
    setEmailInvoiceModal({
      open: true,
      sending: false,
      error: '',
      invoiceId: invoice?.id || null,
      to: client?.email || '',
      subject: `Factura ${baseNumber}`,
      templateId: defaultTemplateId,
      bodyHtml: template?.body_html || '',
      invoiceNumber: baseNumber
    });
  };

  const openEmailBudgetModal = (budget) => {
    const baseNumber = budget?.presupuesto ? budget.presupuesto : `#${budget?.id || ''}`;
    const defaultTemplateId = emailTemplates[0]?.id ? String(emailTemplates[0].id) : '';
    const template = emailTemplates.find((t) => String(t.id) === defaultTemplateId);
    setEmailBudgetModal({
      open: true,
      sending: false,
      error: '',
      budgetId: budget?.id || null,
      to: client?.email || '',
      subject: `Presupuesto ${baseNumber}`,
      templateId: defaultTemplateId,
      bodyHtml: template?.body_html || '',
      budgetNumber: baseNumber
    });
  };

  const sendWhatsappInvoice = async () => {
    if (!whatsappInvoiceModal.invoiceId) return;
    if (!whatsappInvoiceModal.phone.trim()) {
      setWhatsappInvoiceModal((prev) => ({ ...prev, error: 'El teléfono es obligatorio.' }));
      return;
    }
    setWhatsappInvoiceModal((prev) => ({ ...prev, sending: true, error: '' }));
    try {
      const res = await apiFetch(`/api/clients/invoices/${whatsappInvoiceModal.invoiceId}/send-whatsapp-template`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ templateName: whatsappInvoiceModal.templateName })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar por WhatsApp');
      setWhatsappInvoiceModal((prev) => ({ ...prev, sending: false, open: false }));
    } catch (err) {
      setWhatsappInvoiceModal((prev) => ({ ...prev, sending: false, error: err.message }));
    }
  };

  const sendEmailInvoice = async () => {
    if (!emailInvoiceModal.invoiceId) return;
    if (!emailInvoiceModal.to.trim()) {
      setEmailInvoiceModal((prev) => ({ ...prev, error: 'El email es obligatorio.' }));
      return;
    }
    if (!emailInvoiceModal.templateId) {
      setEmailInvoiceModal((prev) => ({ ...prev, error: 'Selecciona una plantilla.' }));
      return;
    }
    setEmailInvoiceModal((prev) => ({ ...prev, sending: true, error: '' }));
    try {
      const res = await apiFetch(`/api/clients/invoices/${emailInvoiceModal.invoiceId}/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          to: emailInvoiceModal.to,
          subject: emailInvoiceModal.subject,
          html: emailInvoiceModal.bodyHtml,
          templateId: emailInvoiceModal.templateId
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar por email');
      setEmailInvoiceModal((prev) => ({ ...prev, sending: false, open: false }));
    } catch (err) {
      setEmailInvoiceModal((prev) => ({ ...prev, sending: false, error: err.message }));
    }
  };

  const sendWhatsappBudget = async () => {
    if (!whatsappBudgetModal.budgetId) return;
    if (!whatsappBudgetModal.phone.trim()) {
      setWhatsappBudgetModal((prev) => ({ ...prev, error: 'El teléfono es obligatorio.' }));
      return;
    }
    setWhatsappBudgetModal((prev) => ({ ...prev, sending: true, error: '' }));
    try {
      const res = await apiFetch(`/api/clients/budgets/${whatsappBudgetModal.budgetId}/send-whatsapp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({})
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar por WhatsApp');
      setWhatsappBudgetModal((prev) => ({ ...prev, sending: false, open: false }));
    } catch (err) {
      setWhatsappBudgetModal((prev) => ({ ...prev, sending: false, error: err.message }));
    }
  };

  const openWhatsappAttachmentModal = (attachment) => {
    setWhatsappAttachmentModal({
      open: true,
      sending: false,
      error: '',
      attachmentId: attachment.id,
      sourceType: attachment.source_type,
      phone: client?.telefono || '',
      clientName: client?.razon_social || '',
      filename: attachment.filename
    });
  };

  const sendWhatsappAttachment = async () => {
    if (!whatsappAttachmentModal.attachmentId) return;
    if (!whatsappAttachmentModal.phone.trim()) {
      setWhatsappAttachmentModal((prev) => ({ ...prev, error: 'El teléfono es obligatorio.' }));
      return;
    }
    setWhatsappAttachmentModal((prev) => ({ ...prev, sending: true, error: '' }));
    try {
      const res = await apiFetch(
        `/api/clients/attachments/${whatsappAttachmentModal.sourceType}/${whatsappAttachmentModal.attachmentId}/send-whatsapp`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ phone: whatsappAttachmentModal.phone })
        }
      );
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar por WhatsApp');
      setWhatsappAttachmentModal((prev) => ({ ...prev, sending: false, open: false }));
    } catch (err) {
      setWhatsappAttachmentModal((prev) => ({ ...prev, sending: false, error: err.message }));
    }
  };

  const sendEmailBudget = async () => {
    if (!emailBudgetModal.budgetId) return;
    if (!emailBudgetModal.to.trim()) {
      setEmailBudgetModal((prev) => ({ ...prev, error: 'El email es obligatorio.' }));
      return;
    }
    if (!emailBudgetModal.templateId) {
      setEmailBudgetModal((prev) => ({ ...prev, error: 'Selecciona una plantilla.' }));
      return;
    }
    setEmailBudgetModal((prev) => ({ ...prev, sending: true, error: '' }));
    try {
      const res = await apiFetch(`/api/clients/budgets/${emailBudgetModal.budgetId}/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          to: emailBudgetModal.to,
          subject: emailBudgetModal.subject,
          html: emailBudgetModal.bodyHtml,
          templateId: emailBudgetModal.templateId
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar por email');
      setEmailBudgetModal((prev) => ({ ...prev, sending: false, open: false }));
    } catch (err) {
      setEmailBudgetModal((prev) => ({ ...prev, sending: false, error: err.message }));
    }
  };

  const sendWhatsappTemplate = async () => {
    if (!client?.id) return;
    if (!client.telefono) {
      setWhatsappTplError('El cliente no tiene teléfono principal.');
      return;
    }
    const confirmText = `¿Enviar la plantilla "${whatsappTpl}" a ${client.razon_social || 'Cliente'} (${client.telefono})?`;
    if (!window.confirm(confirmText)) return;
    setWhatsappTplSending(true);
    setWhatsappTplError('');
    try {
      const res = await apiFetch(`/api/clients/${client.id}/send-whatsapp-template`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ templateName: whatsappTpl })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar la plantilla');
      alert('Plantilla enviada');
    } catch (err) {
      setWhatsappTplError(err.message);
    } finally {
      setWhatsappTplSending(false);
    }
  };

  if (loadingClient) return <p>Cargando...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!client) return null;

  const whatsappTplPreviewMap = {
    utilidad: `Hola {{1}},\n\nHemos recibido tu solicitud desde el formulario de nuestra web.\n\nPara entender mejor lo que necesitas, ¿podemos tener una breve llamada?\n\nRespóndenos con 2 opciones de día y hora que te vengan bien`,
    solicitud_recibida: `Hola {{1}}! Soy Yolanda Jimenez de INTERCONECTA. Hemos recibido tu mensaje. ¿En qué horario te vendría mejor que tengamos una breve llamada para ver si realmente podemos ofrecerte una solución adaptada?`
  };
  const whatsappPreviewRaw = whatsappTplPreviewMap[whatsappTpl] || '';
  const whatsappPreview = whatsappPreviewRaw.replace('{{1}}', client?.razon_social || 'Cliente');

  const activatePortalAccess = async () => {
    if (!client?.email) {
      alert('El cliente no tiene email. Añádelo antes de activar el acceso al portal.');
      return;
    }
    const hasPortal = client.portal_access === true;
    const verbo = hasPortal ? 'Restablecer' : 'Activar';
    if (!window.confirm(`¿${verbo} el acceso al portal para ${client.razon_social || client.email}? Se generará una nueva contraseña y se enviará a ${client.email}.`)) return;
    setPortalBusy(true);
    try {
      const res = await apiFetch(`/api/clients/${client.id}/portal-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error((data && data.message) || 'No se pudo activar el acceso');
      alert(data.message || (hasPortal ? 'Acceso restablecido y email enviado' : 'Acceso activado y email enviado'));
      setClient((prev) => (prev ? { ...prev, portal_access: true } : prev));
    } catch (err) {
      alert(err.message);
    } finally {
      setPortalBusy(false);
    }
  };

  const loadPushHistory = async () => {
    try {
      const res = await apiFetch(`/api/clients/${client.id}/push`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.ok && Array.isArray(data)) setPushHistory(data);
    } catch (_e) { /* historial opcional */ }
  };

  const openPushModal = () => {
    setPushModal(true);
    loadPushHistory();
  };

  const applyPushTemplate = (t) => setPushForm({ title: t.title, body: t.body, route: t.route });

  const sendClientPush = async () => {
    const title = pushForm.title.trim();
    const body = pushForm.body.trim();
    if (!title || !body) {
      alert('Escribe un título y un mensaje.');
      return;
    }
    setPushBusy(true);
    try {
      const res = await apiFetch(`/api/clients/${client.id}/push`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ title, body, route: pushForm.route || undefined })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error((data && data.message) || 'No se pudo enviar la notificación');
      alert(data.message || `Enviada a ${data.sent} dispositivo(s)`);
      setPushModal(false);
      setPushForm({ title: '', body: '', route: '' });
    } catch (err) {
      alert(err.message);
    } finally {
      setPushBusy(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h2 className="mb-1">{client.razon_social}</h2>
            {linesDocument && <DocumentLinesModal {...linesDocument} onClose={() => setLinesDocument(null)} />}
          <div className="d-flex flex-wrap gap-2 text-muted small">
            {client.email && (
              <span><BsEnvelope className="me-1" /><a href={`mailto:${client.email}`}>{client.email}</a></span>
            )}
            {client.telefono && (
              <span><BsTelephone className="me-1" /><a href={`tel:${client.telefono}`}>{client.telefono}</a></span>
            )}
            {client.estado && (
              <span className="badge bg-secondary">{client.estado}</span>
            )}
          </div>
        </div>
        <div className="d-flex gap-2 flex-shrink-0">
          <button
            className={`btn ${client.portal_access ? 'btn-outline-success' : 'btn-outline-secondary'}`}
            type="button"
            onClick={activatePortalAccess}
            disabled={portalBusy}
            title="Crear o restablecer el acceso del cliente al portal y enviarle sus credenciales por email"
          >
            {portalBusy
              ? 'Enviando...'
              : client.portal_access
                ? '↻ Restablecer acceso portal'
                : 'Activar acceso portal'}
          </button>
          {client.portal_access && (
            <button
              className="btn btn-outline-primary"
              type="button"
              onClick={openPushModal}
              title="Enviar una notificación push a la app móvil del cliente"
            >
              🔔 Enviar notificación
            </button>
          )}
          <Link className="btn btn-outline-primary" to={`/clientes/${client.id}/editar`}>Editar</Link>
        </div>
      </div>

      {pushModal && (
        <div className="modal-backdrop-custom" onClick={() => !pushBusy && setPushModal(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div className="card shadow" style={{ maxWidth: 560, width: '100%', maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <div className="card-body">
              <h5 className="card-title mb-1">Enviar notificación push</h5>
              <p className="text-muted small mb-3">Se enviará a la app móvil de {client.razon_social || 'este cliente'}.</p>

              <div className="mb-3">
                <label className="form-label small text-muted">Plantillas rápidas</label>
                <div className="d-flex flex-wrap gap-2">
                  {PUSH_TEMPLATES.map((t) => (
                    <button key={t.label} type="button" className="btn btn-sm btn-outline-secondary"
                      onClick={() => applyPushTemplate(t)}>{t.label}</button>
                  ))}
                </div>
              </div>

              <div className="mb-2">
                <label className="form-label small">Título</label>
                <input className="form-control" maxLength={80} value={pushForm.title}
                  onChange={(e) => setPushForm((f) => ({ ...f, title: e.target.value }))}
                  placeholder="Ej: Tu factura está lista" />
              </div>
              <div className="mb-2">
                <label className="form-label small">Mensaje</label>
                <textarea className="form-control" rows={3} maxLength={300} value={pushForm.body}
                  onChange={(e) => setPushForm((f) => ({ ...f, body: e.target.value }))}
                  placeholder="Escribe el mensaje de la notificación" />
              </div>
              <div className="mb-3">
                <label className="form-label small">Al tocar la notificación, abrir</label>
                <select className="form-select" value={pushForm.route}
                  onChange={(e) => setPushForm((f) => ({ ...f, route: e.target.value }))}>
                  {PUSH_ROUTES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </div>

              {pushHistory.length > 0 && (
                <div className="mb-3">
                  <label className="form-label small text-muted">Últimos envíos a este cliente</label>
                  <div className="list-group list-group-flush small" style={{ maxHeight: 160, overflowY: 'auto' }}>
                    {pushHistory.map((h) => (
                      <div key={h.id} className="list-group-item px-0 py-1">
                        <div className="d-flex justify-content-between">
                          <strong className="text-truncate">{h.title}</strong>
                          <span className="text-muted ms-2 flex-shrink-0">
                            {new Date(h.created_at).toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </div>
                        <div className="text-muted">
                          {h.sent}/{h.devices} dispositivo(s){h.route ? ` · abre ${h.route}` : ''}
                          {h.sent_by_email ? ` · por ${h.sent_by_email}` : ''}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-end gap-2">
                <button className="btn btn-outline-secondary" onClick={() => setPushModal(false)} disabled={pushBusy}>Cancelar</button>
                <button className="btn btn-primary" onClick={sendClientPush} disabled={pushBusy || !pushForm.title.trim() || !pushForm.body.trim()}>
                  {pushBusy ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <nav className="client-tabs mb-3" aria-label="Secciones del cliente">
        {TAB_GROUPS.map((group) => (
          <div className="client-tabs__group" key={group.label}>
            <span className="client-tabs__group-label">{group.label}</span>
            <div className="client-tabs__pills" role="tablist" aria-label={group.label}>
              {group.items.map(({ name, Icon }) => {
                const isActive = activeTab === name;
                return (
                  <button
                    key={name}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    className={`client-tab ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveTab(name)}
                  >
                    {Icon && <Icon className="client-tab__icon" aria-hidden="true" />}
                    <span className="client-tab__label">{name}</span>
                    {name !== 'Ficha' && name !== 'Perfil IA' && Number(tabCounts[name]) > 0 && (
                      <span className="badge rounded-pill bg-primary ms-1" style={{ fontSize: '0.7rem' }}>{tabCounts[name]}</span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      {activeTab === 'Ficha' && (
        <>
          <div className="card shadow-sm">
            <div className="card-body">
              <h5>Datos del cliente</h5>
              <div className="row">
                <div className="col-md-6">
                  <table className="table table-borderless table-sm mb-0">
                    <tbody>
                      <tr><td className="text-muted" style={{ width: '140px' }}>Razón Social</td><td>{client.razon_social}</td></tr>
                      <tr><td className="text-muted">CIF/NIF</td><td>{client.cif || '-'}</td></tr>
                      <tr>
                        <td className="text-muted">Email</td>
                        <td>{client.email ? <a href={`mailto:${client.email}`}>{client.email}</a> : '-'}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Teléfono</td>
                        <td>
                          {client.telefono ? (
                            <>
                              <a href={`tel:${client.telefono}`}>{client.telefono}</a>
                              {buildWhatsappLink(client.telefono) && (
                                <a href={buildWhatsappLink(client.telefono)} target="_blank" rel="noreferrer" className="ms-2 text-success" title="Abrir en WhatsApp">
                                  <BsWhatsapp />
                                </a>
                              )}
                            </>
                          ) : '-'}
                        </td>
                      </tr>
                      <tr><td className="text-muted">Tipo</td><td>{client.tipo || '-'}</td></tr>
                      <tr><td className="text-muted">Estado</td><td>{client.estado || '-'}</td></tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="table table-borderless table-sm mb-0">
                    <tbody>
                      <tr><td className="text-muted" style={{ width: '140px' }}>Dirección</td><td>{client.direccion || '-'}</td></tr>
                      <tr><td className="text-muted">Código Postal</td><td>{client.codigo_postal || '-'}</td></tr>
                      <tr><td className="text-muted">Ciudad</td><td>{client.ciudad || '-'}</td></tr>
                      <tr><td className="text-muted">Provincia</td><td>{client.provincia || '-'}</td></tr>
                      <tr><td className="text-muted">País</td><td>{client.pais || '-'}</td></tr>
                      <tr><td className="text-muted">ID Dolibarr</td><td>{client.dolibarr_id || '-'}</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr />
              <h6>Canal captación</h6>
              <table className="table table-borderless table-sm mb-0" style={{ maxWidth: '400px' }}>
                <tbody>
                  <tr><td className="text-muted" style={{ width: '140px' }}>Canal</td><td>{client.canal_captacion || 'Sin establecer'}</td></tr>
                  <tr><td className="text-muted">En embudo</td><td>{client.lead_pipeline ? 'Sí' : 'No'}</td></tr>
                  {client.canal_captacion === 'Webhook' && (
                    <>
                      <tr><td className="text-muted">UTM medium</td><td>{client.utm_medium || '-'}</td></tr>
                      <tr><td className="text-muted">Campaña</td><td>{client.utm_campaign || '-'}</td></tr>
                    </>
                  )}
                </tbody>
              </table>
              {(client.note_public || client.note_private) && (
                <div className="row mt-3">
                  {client.note_public && (
                    <div className="col-12 col-md-6">
                      <h6>Nota pública</h6>
                      <p className="bg-light p-2 rounded" style={{ whiteSpace: 'pre-line' }}>{client.note_public}</p>
                    </div>
                  )}
                  {client.note_private && (
                    <div className="col-12 col-md-6">
                      <h6>Nota privada</h6>
                      <p className="bg-light p-2 rounded" style={{ whiteSpace: 'pre-line' }}>{client.note_private}</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="card shadow-sm mt-3">
            <div className="card-body">
              <h6 className="mb-3">Enviar plantilla WhatsApp</h6>
              <div className="row g-2 align-items-end">
                <div className="col-md-6">
                  <label className="form-label small">Plantilla</label>
                  <select
                    className="form-select"
                    value={whatsappTpl}
                    onChange={(e) => setWhatsappTpl(e.target.value)}
                  >
                    <option value="utilidad">utilidad</option>
                    <option value="solicitud_recibida">solicitud_recibida</option>
                  </select>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={sendWhatsappTemplate}
                    disabled={whatsappTplSending || !client.telefono}
                  >
                    {whatsappTplSending ? 'Enviando...' : 'Enviar'}
                  </button>
                </div>
              </div>
              {whatsappPreview && (
                <div className="mt-2 p-2 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }}>
                  {whatsappPreview}
                </div>
              )}
              <div className="text-muted small mt-1">
                Se enviará al teléfono principal del cliente.
              </div>
              {whatsappTplError && <div className="alert alert-danger py-2 mt-2">{whatsappTplError}</div>}
            </div>
          </div>
        </>
      )}

      {whatsappInvoiceModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar factura por WhatsApp</h5>
                <button
                  className="btn-close"
                  onClick={() => setWhatsappInvoiceModal((prev) => ({ ...prev, open: false, error: '' }))}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label small">Teléfono *</label>
                  <input
                    className="form-control"
                    value={whatsappInvoiceModal.phone}
                    onChange={(e) => setWhatsappInvoiceModal((prev) => ({ ...prev, phone: e.target.value }))}
                    placeholder="+34 600 000 000"
                    disabled
                  />
                  {!whatsappInvoiceModal.phone && (
                    <div className="text-muted small mt-1">El cliente no tiene teléfono principal.</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Razón social</label>
                  <input
                    className="form-control"
                    value={whatsappInvoiceModal.clientName}
                    onChange={(e) => setWhatsappInvoiceModal((prev) => ({ ...prev, clientName: e.target.value }))}
                    placeholder="Cliente"
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Nº de factura</label>
                  <input
                    className="form-control"
                    value={whatsappInvoiceModal.invoiceNumber}
                    onChange={(e) => setWhatsappInvoiceModal((prev) => ({ ...prev, invoiceNumber: e.target.value }))}
                    placeholder="FAC-0001"
                    disabled
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label small">Plantilla</label>
                  <select
                    className="form-select"
                    value={whatsappInvoiceModal.templateName}
                    onChange={(e) => setWhatsappInvoiceModal((prev) => ({ ...prev, templateName: e.target.value }))}
                  >
                    {docTemplates.length === 0 && (
                      <option value={whatsappInvoiceModal.templateName}>{whatsappInvoiceModal.templateName}</option>
                    )}
                    {docTemplates.map((t) => (
                      <option key={t.id} value={t.name}>
                        {t.name}{t.variables?.length ? ` (${t.variables.length} var.)` : ''}
                      </option>
                    ))}
                  </select>
                  <div className="form-text">Solo plantillas de Meta que adjuntan documento.</div>
                </div>
                {whatsappInvoiceModal.error && (
                  <div className="alert alert-danger py-2 mt-3">{whatsappInvoiceModal.error}</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setWhatsappInvoiceModal((prev) => ({ ...prev, open: false, error: '' }))}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-success"
                  disabled={whatsappInvoiceModal.sending}
                  onClick={sendWhatsappInvoice}
                >
                  {whatsappInvoiceModal.sending ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {whatsappBudgetModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar presupuesto por WhatsApp</h5>
                <button
                  className="btn-close"
                  onClick={() => setWhatsappBudgetModal((prev) => ({ ...prev, open: false, error: '' }))}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label small">Teléfono *</label>
                  <input
                    className="form-control"
                    value={whatsappBudgetModal.phone}
                    onChange={(e) => setWhatsappBudgetModal((prev) => ({ ...prev, phone: e.target.value }))}
                    placeholder="+34 600 000 000"
                    disabled
                  />
                  {!whatsappBudgetModal.phone && (
                    <div className="text-muted small mt-1">El cliente no tiene teléfono principal.</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Razón social</label>
                  <input
                    className="form-control"
                    value={whatsappBudgetModal.clientName}
                    onChange={(e) => setWhatsappBudgetModal((prev) => ({ ...prev, clientName: e.target.value }))}
                    placeholder="Cliente"
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Nº de presupuesto</label>
                  <input
                    className="form-control"
                    value={whatsappBudgetModal.budgetNumber}
                    onChange={(e) => setWhatsappBudgetModal((prev) => ({ ...prev, budgetNumber: e.target.value }))}
                    placeholder="PR-0001"
                    disabled
                  />
                </div>
                <div className="text-muted small">Plantilla: envio_documentacion_solicitada</div>
                {whatsappBudgetModal.error && (
                  <div className="alert alert-danger py-2 mt-3">{whatsappBudgetModal.error}</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setWhatsappBudgetModal((prev) => ({ ...prev, open: false, error: '' }))}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-success"
                  disabled={whatsappBudgetModal.sending}
                  onClick={sendWhatsappBudget}
                >
                  {whatsappBudgetModal.sending ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {whatsappAttachmentModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar adjunto por WhatsApp</h5>
                <button
                  className="btn-close"
                  onClick={() => setWhatsappAttachmentModal((prev) => ({ ...prev, open: false, error: '' }))}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label small">Archivo</label>
                  <input className="form-control" value={whatsappAttachmentModal.filename} disabled />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Teléfono *</label>
                  <input
                    className="form-control"
                    value={whatsappAttachmentModal.phone}
                    onChange={(e) => setWhatsappAttachmentModal((prev) => ({ ...prev, phone: e.target.value }))}
                    placeholder="+34 600 000 000"
                  />
                  {!whatsappAttachmentModal.phone && (
                    <div className="text-muted small mt-1">El cliente no tiene teléfono principal.</div>
                  )}
                </div>
                <div className="text-muted small">Plantilla: envio_documentacion_solicitada</div>
                {whatsappAttachmentModal.error && (
                  <div className="alert alert-danger py-2 mt-3">{whatsappAttachmentModal.error}</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setWhatsappAttachmentModal((prev) => ({ ...prev, open: false, error: '' }))}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-success"
                  disabled={whatsappAttachmentModal.sending}
                  onClick={sendWhatsappAttachment}
                >
                  {whatsappAttachmentModal.sending ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {emailInvoiceModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar factura por email</h5>
                <button
                  className="btn-close"
                  onClick={() => setEmailInvoiceModal((prev) => ({ ...prev, open: false, error: '' }))}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label small">Destinatario *</label>
                  <input
                    className="form-control"
                    type="email"
                    value={emailInvoiceModal.to}
                    onChange={(e) => setEmailInvoiceModal((prev) => ({ ...prev, to: e.target.value }))}
                    placeholder="cliente@dominio.com"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Asunto</label>
                  <input
                    className="form-control"
                    value={emailInvoiceModal.subject}
                    onChange={(e) => setEmailInvoiceModal((prev) => ({ ...prev, subject: e.target.value }))}
                    placeholder={`Factura ${emailInvoiceModal.invoiceNumber}`}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Plantilla</label>
                  <select
                    className="form-select"
                    value={emailInvoiceModal.templateId}
                    onChange={(e) => {
                      const selected = emailTemplates.find((t) => String(t.id) === e.target.value);
                      setEmailInvoiceModal((prev) => ({
                        ...prev,
                        templateId: e.target.value,
                        bodyHtml: selected?.body_html || ''
                      }));
                    }}
                    disabled={loadingEmailTemplates}
                  >
                    <option value="">Selecciona plantilla</option>
                    {emailTemplates.map((tpl) => (
                      <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
                    ))}
                  </select>
                  {!loadingEmailTemplates && emailTemplates.length === 0 && (
                    <div className="text-muted small mt-1">No hay plantillas guardadas en Comunicaciones.</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Vista previa</label>
                  {emailInvoiceModal.bodyHtml ? (
                    <EmailBody text={emailInvoiceModal.bodyHtml} />
                  ) : (
                    <div className="text-muted small">Selecciona una plantilla para previsualizar.</div>
                  )}
                </div>
                {emailInvoiceModal.error && (
                  <div className="alert alert-danger py-2 mt-2">{emailInvoiceModal.error}</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setEmailInvoiceModal((prev) => ({ ...prev, open: false, error: '' }))}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  disabled={emailInvoiceModal.sending}
                  onClick={sendEmailInvoice}
                >
                  {emailInvoiceModal.sending ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {emailBudgetModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar presupuesto por email</h5>
                <button
                  className="btn-close"
                  onClick={() => setEmailBudgetModal((prev) => ({ ...prev, open: false, error: '' }))}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label small">Destinatario *</label>
                  <input
                    className="form-control"
                    type="email"
                    value={emailBudgetModal.to}
                    onChange={(e) => setEmailBudgetModal((prev) => ({ ...prev, to: e.target.value }))}
                    placeholder="cliente@dominio.com"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Asunto</label>
                  <input
                    className="form-control"
                    value={emailBudgetModal.subject}
                    onChange={(e) => setEmailBudgetModal((prev) => ({ ...prev, subject: e.target.value }))}
                    placeholder={`Presupuesto ${emailBudgetModal.budgetNumber}`}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Plantilla</label>
                  <select
                    className="form-select"
                    value={emailBudgetModal.templateId}
                    onChange={(e) => {
                      const selected = emailTemplates.find((t) => String(t.id) === e.target.value);
                      setEmailBudgetModal((prev) => ({
                        ...prev,
                        templateId: e.target.value,
                        bodyHtml: selected?.body_html || ''
                      }));
                    }}
                    disabled={loadingEmailTemplates}
                  >
                    <option value="">Selecciona plantilla</option>
                    {emailTemplates.map((tpl) => (
                      <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
                    ))}
                  </select>
                  {!loadingEmailTemplates && emailTemplates.length === 0 && (
                    <div className="text-muted small mt-1">No hay plantillas guardadas en Comunicaciones.</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label small">Vista previa</label>
                  {emailBudgetModal.bodyHtml ? (
                    <EmailBody text={emailBudgetModal.bodyHtml} />
                  ) : (
                    <div className="text-muted small">Selecciona una plantilla para previsualizar.</div>
                  )}
                </div>
                {emailBudgetModal.error && (
                  <div className="alert alert-danger py-2 mt-2">{emailBudgetModal.error}</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setEmailBudgetModal((prev) => ({ ...prev, open: false, error: '' }))}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  disabled={emailBudgetModal.sending}
                  onClick={sendEmailBudget}
                >
                  {emailBudgetModal.sending ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'Notas' && (
        <div className="row g-3">
          <div className="col-12 col-lg-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5>{editingNoteId ? 'Editar nota' : 'Crear nota'}</h5>
                {noteError && <div className="alert alert-danger">{noteError}</div>}
                <form onSubmit={handleSaveNote} className="row g-2">
                  <div className="col-12">
                    <label className="form-label">Título *</label>
                    <input
                      className="form-control"
                      value={noteForm.titulo}
                      onChange={(e) => setNoteForm((prev) => ({ ...prev, titulo: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Comentarios</label>
                    <textarea
                      className="form-control"
                      rows="6"
                      value={noteForm.comentarios}
                      onChange={(e) => setNoteForm((prev) => ({ ...prev, comentarios: e.target.value }))}
                    />
                  </div>
                  <div className="col-12 d-flex gap-2">
                    <button className="btn btn-primary w-100" type="submit">{editingNoteId ? 'Guardar cambios' : 'Crear nota'}</button>
                    {editingNoteId && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => { setEditingNoteId(null); setNoteForm({ titulo: '', comentarios: '' }); }}
                      >
                        Cancelar
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5>Notas</h5>
                {loadingNotes ? (
                  <p>Cargando...</p>
                ) : notes.length ? (
                  <div className="d-flex flex-column gap-2">
                    {notes.map((note) => (
                      <div key={note.id} className="border rounded p-3">
                        <div className="d-flex justify-content-between align-items-start gap-2">
                          <div>
                            <div className="fw-semibold">{note.titulo}</div>
                            <div className="text-muted small">{formatDate(note.created_at)}</div>
                          </div>
                          <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => startEditNote(note)}>
                              Editar
                            </button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteNote(note.id)}>
                              Eliminar
                            </button>
                          </div>
                        </div>
                        {note.comentarios && (
                          <div className="mt-2" style={{ whiteSpace: 'pre-wrap' }}>{note.comentarios}</div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>Sin notas.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'Contactos' && (
        <div className="row g-3">
          <div className="col-12 col-lg-4">
      <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5>{editingContactId ? 'Editar contacto' : 'Crear contacto'}</h5>
                {contactError && <div className="alert alert-danger">{contactError}</div>}
                <form onSubmit={handleCreateContact} className="row g-2">
                  <div className="col-12">
                    <label className="form-label">Nombre *</label>
                    <input
                      className="form-control"
                      value={contactForm.nombre}
                      onChange={(e) => setContactForm((prev) => ({ ...prev, nombre: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Cargo</label>
                    <input
                      className="form-control"
                      value={contactForm.cargo}
                      onChange={(e) => setContactForm((prev) => ({ ...prev, cargo: e.target.value }))}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Email</label>
                    <input
                      className="form-control"
                      type="email"
                      value={contactForm.email}
                      onChange={(e) => setContactForm((prev) => ({ ...prev, email: e.target.value }))}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Teléfono</label>
                    <input
                      className="form-control"
                      value={contactForm.telefono}
                      onChange={(e) => setContactForm((prev) => ({ ...prev, telefono: e.target.value }))}
                    />
                  </div>
                  <div className="col-12 d-flex gap-2">
                    <button className="btn btn-primary w-100" type="submit">{editingContactId ? 'Guardar cambios' : 'Crear contacto'}</button>
                    {editingContactId && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => { setEditingContactId(null); setContactForm({ nombre: '', cargo: '', email: '', telefono: '' }); }}
                      >
                        Cancelar
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5>Contactos</h5>
                {loadingContacts ? (
                  <p>Cargando...</p>
                ) : contacts.length ? (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Cargo</th>
                          <th>Email</th>
                          <th>Teléfono</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {contacts.map((c) => (
                          <tr key={c.id}>
                            <td>{c.nombre}</td>
                            <td>{c.cargo || '-'}</td>
                            <td>{c.email ? <a href={`mailto:${c.email}`}>{c.email}</a> : '-'}</td>
                            <td>
                              {c.telefono ? (
                                <>
                                  <a href={`tel:${c.telefono}`}>{c.telefono}</a>
                                  {buildWhatsappLink(c.telefono) && (
                                    <a href={buildWhatsappLink(c.telefono)} className="ms-2 text-success" title="WhatsApp" target="_blank" rel="noreferrer">
                                      <BsWhatsapp />
                                    </a>
                                  )}
                                </>
                              ) : '-'}
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => startEditContact(c)}>
                                  Editar
                                </button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteContact(c.id)}>
                                  Eliminar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>Sin contactos.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'Comunicaciones' && (
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Histórico de comunicaciones</h5>
              <div className="d-flex align-items-center gap-2">
                <div className="text-muted small">{commsTotal ? `${commsTotal} registros` : ''}</div>
                <button className="btn btn-sm btn-primary" type="button" onClick={openManualCommModal}>
                  Nueva comunicación
                </button>
              </div>
            </div>
            {commsError && <div className="alert alert-danger">{commsError}</div>}
            <div className="row g-2 mb-2">
              <div className="col-md-4">
                <input
                  className="form-control form-control-sm"
                  placeholder="Buscar asunto o cuerpo"
                  value={commsFilters.search}
                  onChange={(e) => {
                    setCommsFilters((p) => ({ ...p, search: e.target.value }));
                    setCommsPage(1);
                  }}
                />
              </div>
              <div className="col-md-3">
                <select
                  className="form-select form-select-sm"
                  value={commsFilters.canal}
                  onChange={(e) => {
                    setCommsFilters((p) => ({ ...p, canal: e.target.value }));
                    setCommsPage(1);
                  }}
                >
                  <option value="">Todos los canales</option>
                  <option value="email">Email</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="call">Llamada</option>
                  <option value="note">Nota</option>
                </select>
              </div>
              <div className="col-md-3">
                <select
                  className="form-select form-select-sm"
                  value={commsFilters.direccion}
                  onChange={(e) => {
                    setCommsFilters((p) => ({ ...p, direccion: e.target.value }));
                    setCommsPage(1);
                  }}
                >
                  <option value="">Dirección</option>
                  <option value="in">Entrante</option>
                  <option value="out">Saliente</option>
                </select>
              </div>
            </div>
            {loadingComms ? (
              <p>Cargando...</p>
            ) : communications.length ? (
              <>
                <div className="table-responsive">
                  <table className="table table-sm align-middle">
                    <thead>
                      <tr>
                        <th>Canal</th>
                        <th>Dirección</th>
                        <th>Asunto / Preview</th>
                        <th>Fecha</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {communications.map((c) => {
                        const icon = c.canal === 'whatsapp'
                          ? <BsWhatsapp className="me-1 text-success" />
                          : c.canal === 'call'
                            ? <BsTelephone className="me-1 text-primary" />
                            : c.canal === 'note'
                              ? <BsChatLeftText className="me-1 text-secondary" />
                              : <BsEnvelope className="me-1" />;
                        const channelLabel = c.canal === 'whatsapp' && c.provider ? `WhatsApp ${c.provider === 'qr' ? 'QR' : 'API'}`
                          : c.canal === 'call' ? 'Llamada' : c.canal === 'note' ? 'Nota' : c.canal;
                        const preview = (c.cuerpo_texto || '').slice(0, 140);
                        return (
                          <tr key={`${c.canal}-${c.id}`} style={{ cursor: 'pointer' }} onClick={() => setSelectedComm(c)}>
                            <td>{icon}{channelLabel}</td>
                            <td>
                              <span className={`badge ${c.direccion === 'in' ? 'bg-info text-dark' : 'bg-secondary'}`}>
                                {c.direccion === 'in' ? 'Entrante' : 'Saliente'}
                              </span>
                            </td>
                            <td>
                              <div className="fw-bold mb-0">{c.asunto || '(sin asunto)'}</div>
                              <div className="text-muted small">{preview}{c.cuerpo_texto && c.cuerpo_texto.length > 140 ? '…' : ''}</div>
                            </td>
                            <td className="small">{new Date(c.fecha).toLocaleString()}</td>
                            <td>
                              <span className={`badge bg-${c.estado === 'auto_resuelto' ? 'success' : c.estado === 'pendiente_revision' ? 'warning text-dark' : 'light text-dark border'}`}>
                                {c.estado || 'registrado'}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <div className="text-muted small">Página {commsPage} de {Math.max(1, Math.ceil(commsTotal / commsPageSize))}</div>
                  <div className="btn-group">
                    <button className="btn btn-sm btn-outline-secondary" disabled={commsPage <= 1} onClick={() => setCommsPage((p) => Math.max(1, p - 1))}>Anterior</button>
                    <button className="btn btn-sm btn-outline-secondary" disabled={commsPage >= Math.ceil(commsTotal / commsPageSize)} onClick={() => setCommsPage((p) => p + 1)}>Siguiente</button>
                  </div>
                </div>
              </>
            ) : (
              <p>No hay comunicaciones.</p>
            )}
          </div>
        </div>
      )}

      {activeTab === 'WhatsApp' && (
        <ClientWhatsappTab clientId={id} onChanged={fetchTabCounts} />
      )}

      {activeTab === 'Servicios' && (
        <ClientServicesTab clientId={id} onChanged={fetchTabCounts} />
      )}

      {activeTab === 'Bolsas de horas' && (
        <ClientTimePacksTab clientId={id} onChanged={fetchTabCounts} />
      )}

      {activeTab === 'Adjuntos' && (
        <div className="card shadow-sm">
          <div className="card-body">
            <h5>Adjuntos</h5>
            <div className="d-flex gap-2 align-items-center mb-2">
              <input
                key={clientAttachmentInputKey}
                type="file"
                className="form-control form-control-sm"
                onChange={(e) => setClientAttachmentFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              />
              <button
                className="btn btn-sm btn-primary"
                type="button"
                disabled={!clientAttachmentFile || clientAttachmentUploading}
                onClick={uploadClientAttachment}
              >
                {clientAttachmentUploading ? 'Subiendo...' : 'Subir'}
              </button>
            </div>
            {clientAttachmentsLoading && <div className="text-muted small">Cargando...</div>}
            {clientAttachmentsError && <div className="text-danger small">{clientAttachmentsError}</div>}
            {!clientAttachmentsLoading && !clientAttachments.length ? (
              <p className="text-muted mb-0">Sin adjuntos.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>Archivo</th>
                      <th>Origen</th>
                      <th>Fecha</th>
                      <th className="text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientAttachments.map((f) => (
                      <tr key={`${f.source_type}-${f.id}`}>
                        <td>
                          <div className="fw-semibold">{f.filename}</div>
                          {f.size ? <div className="text-muted small">{Math.round((Number(f.size) / 1024) * 10) / 10} KB</div> : null}
                        </td>
                        <td>
                          {f.source_type === 'budget' ? (
                            <button
                              className="btn btn-link btn-sm p-0 text-decoration-none"
                              type="button"
                              onClick={() => setActiveTab('Presupuestos')}
                              title="Ver presupuesto"
                            >
                              Presupuesto: {f.budget_presupuesto || `#${f.budget_id}`}
                            </button>
                          ) : (
                            <span className="badge bg-secondary">Libre</span>
                          )}
                        </td>
                        <td className="text-muted small text-nowrap">
                          {f.created_at ? new Date(f.created_at).toLocaleDateString() : ''}
                        </td>
                        <td className="text-end">
                          <div className="btn-group btn-group-sm">
                            <button
                              className="btn btn-outline-primary"
                              type="button"
                              onClick={() => {
                                const endpoint = f.source_type === 'budget'
                                  ? `/api/clients/budget-attachments/${f.id}/download`
                                  : `/api/clients/client-attachments/${f.id}/download`;
                                downloadFile(endpoint, f.filename);
                              }}
                            >
                              Descargar
                            </button>
                            <button
                              className="btn btn-outline-success"
                              type="button"
                              onClick={() => openWhatsappAttachmentModal(f)}
                              title="Enviar por WhatsApp"
                            >
                              WhatsApp
                            </button>
                            {f.source_type === 'client' && (
                              <button
                                className="btn btn-outline-danger"
                                type="button"
                                onClick={() => deleteClientAttachment(f.id)}
                              >
                                Eliminar
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'Proyectos' && (
        <>
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Proyectos del cliente</h5>
              <button className="btn btn-primary btn-sm" type="button" onClick={() => setProjectModalOpen(true)}>
                + Crear proyecto
              </button>
            </div>
            {clientProjects.length ? (
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>Título</th>
                      <th>Estado</th>
                      <th>Tareas</th>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientProjects.map((p) => (
                      <tr key={p.id}>
                        <td>
                          <Link to={`/proyectos/${p.id}/tareas`} className="text-decoration-none">
                            {p.titulo}
                          </Link>
                        </td>
                        <td>{p.estado}</td>
                        <td>
                          <span className="badge bg-light text-dark border">
                            {(p.tasks_abiertas ?? 0)}/{(p.tasks_total ?? 0)}
                          </span>
                        </td>
                        <td>{p.fecha_inicio ? p.fecha_inicio.slice(0, 10) : '-'}</td>
                        <td>{p.fecha_fin ? p.fecha_fin.slice(0, 10) : '-'}</td>
                        <td className="text-end">
                          <div className="d-flex gap-2 justify-content-end flex-wrap">
                            <Link className="btn btn-sm btn-outline-primary" to={`/proyectos/${p.id}`}>
                              Editar proyecto
                            </Link>
                            <Link className="btn btn-sm btn-outline-secondary" to={`/proyectos/${p.id}/tareas`}>
                              Ver tareas
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted mb-0">Sin proyectos asociados.</p>
            )}
          </div>
        </div>
        <ProjectCreateModal
          open={projectModalOpen}
          clientId={id}
          clientName={client?.razon_social}
          onClose={() => setProjectModalOpen(false)}
          onCreated={() => { setProjectModalOpen(false); fetchProjects(); }}
        />
        </>
      )}

      {selectedComm && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedComm.asunto || '(sin asunto)'}</h5>
                <button className="btn-close" onClick={() => setSelectedComm(null)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-2 text-muted small">
                  {selectedComm.canal} · {selectedComm.direccion === 'in' ? 'Entrante' : 'Saliente'} · {new Date(selectedComm.fecha).toLocaleString()}
                </div>
                <div className="mb-2">
                  <strong>Remitente:</strong> {selectedComm.remitente || selectedComm.from_address || '-'}<br />
                  <strong>Destinatario:</strong> {selectedComm.destinatario || selectedComm.to_address || '-'}
                </div>
                <div className="mb-3">
                  <strong>Contenido:</strong>
                  <EmailBody text={selectedComm.cuerpo_texto} />
                </div>
                {selectedComm.canal === 'email' && selectedComm.ai_suggested_body && (
                  <div className="mb-3">
                    <h6>Borrador IA</h6>
                    <div className="small text-muted">Intent: {selectedComm.ai_intent || '-'} · Confianza: {selectedComm.ai_confidence || '-'}</div>
                    <div className="p-2 border rounded" style={{ whiteSpace: 'pre-wrap' }}>
                      {selectedComm.ai_suggested_body}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setSelectedComm(null)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {manualCommOpen && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Nueva comunicación</h5>
                <button className="btn-close" onClick={() => setManualCommOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-2 mb-2">
                  <div className="col-md-4">
                    <label className="form-label small">Canal</label>
                    <select
                      className="form-select"
                      value={manualCommForm.canal}
                      onChange={(e) => setManualCommForm((p) => ({ ...p, canal: e.target.value }))}
                    >
                      <option value="call">Llamada</option>
                      <option value="whatsapp">WhatsApp</option>
                      <option value="email">Email</option>
                      <option value="note">Nota</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Dirección</label>
                    <select
                      className="form-select"
                      value={manualCommForm.direccion}
                      onChange={(e) => setManualCommForm((p) => ({ ...p, direccion: e.target.value }))}
                    >
                      <option value="out">Saliente</option>
                      <option value="in">Entrante</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Fecha</label>
                    <input
                      className="form-control"
                      type="datetime-local"
                      value={manualCommForm.fecha}
                      onChange={(e) => setManualCommForm((p) => ({ ...p, fecha: e.target.value }))}
                    />
                  </div>
                </div>
                <div className="mb-2">
                  <label className="form-label small">Asunto (opcional)</label>
                  <input
                    className="form-control"
                    value={manualCommForm.asunto}
                    onChange={(e) => setManualCommForm((p) => ({ ...p, asunto: e.target.value }))}
                  />
                </div>
                <div>
                  <label className="form-label small">Contenido</label>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={manualCommForm.cuerpo_texto}
                    onChange={(e) => setManualCommForm((p) => ({ ...p, cuerpo_texto: e.target.value }))}
                    placeholder="Escribe el resumen de la comunicación"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setManualCommOpen(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={saveManualComm} disabled={manualCommSaving}>
                  {manualCommSaving ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {['Presupuestos', 'Facturas', 'Facturas recurrentes', 'Dominios', 'Hosting', 'Tareas'].includes(activeTab) && (
        <div className="card shadow-sm">
          <div className="card-body">
            {activeTab === 'Tareas' && (
              <>
                <h5>Tareas del cliente</h5>
                {clientTasks.length ? (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Título</th>
                          <th>Importancia</th>
                          <th>Estado</th>
                          <th>Asignada a</th>
                          <th>Comentarios</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientTasks.map((t) => (
                          <tr key={t.id}>
                            <td>{t.titulo}</td>
                            <td><span className={`badge bg-${t.importance === 'alta' ? 'danger' : t.importance === 'media' ? 'warning text-dark' : 'secondary'}`}>{t.importance || '-'}</span></td>
                            <td>{t.estado}</td>
                            <td>{t.user_name || t.user_email || '-'}</td>
                            <td>{t.comentarios || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <p>No hay tareas asociadas.</p>}
              </>
            )}
            {activeTab === 'Dominios' && (
              <>
                <h5>Dominios</h5>
                <form className="row g-2 mb-3" onSubmit={submitDomain}>
                  <div className="col-md-4">
                    <input className="form-control" placeholder="Dominio *" value={domainForm.dominio} onChange={(e) => setDomainForm((p) => ({ ...p, dominio: e.target.value }))} required />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small mb-0">Fecha registro</label>
                    <input className="form-control" type="date" value={domainForm.fechaRegistro} onChange={(e) => setDomainForm((p) => ({ ...p, fechaRegistro: e.target.value }))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small mb-0">Fecha renovación</label>
                    <input className="form-control" type="date" value={domainForm.fechaRenovacion} onChange={(e) => setDomainForm((p) => ({ ...p, fechaRenovacion: e.target.value }))} />
                  </div>
                  <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-primary w-100" type="submit">{domainForm.id ? 'Actualizar' : 'Añadir'}</button>
                  </div>
                </form>
                {domains.length ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Dominio</th>
                          <th>Registro</th>
                          <th>Renovación</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {domains.map((d) => (
                          <tr key={d.id}>
                            <td>{d.dominio}</td>
                            <td>{d.fecha_registro || '-'}</td>
                            <td>{d.fecha_renovacion || '-'}</td>
                            <td className="text-end">
                              <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => editDomain(d)}>Editar</button>
                              <button className="btn btn-sm btn-outline-danger" onClick={() => deleteDomain(d.id)}>Eliminar</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <p>No hay dominios.</p>}
              </>
            )}

            {activeTab === 'Hosting' && (
              <>
                <h5>Hosting</h5>
                <form className="row g-2 mb-3" onSubmit={submitHosting}>
                  <div className="col-md-3">
                    <input className="form-control" placeholder="Hosting *" value={hostingForm.hosting} onChange={(e) => setHostingForm((p) => ({ ...p, hosting: e.target.value }))} required />
                  </div>
                  <div className="col-md-9">
                    <input
                      className="form-control"
                      placeholder="Características"
                      value={hostingForm.caracteristicas}
                      onChange={(e) => setHostingForm((p) => ({ ...p, caracteristicas: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small mb-0">Fecha alta</label>
                    <input className="form-control" type="date" value={hostingForm.fechaAlta} onChange={(e) => setHostingForm((p) => ({ ...p, fechaAlta: e.target.value }))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small mb-0">Renovación</label>
                    <input className="form-control" type="date" value={hostingForm.fechaRenovacion} onChange={(e) => setHostingForm((p) => ({ ...p, fechaRenovacion: e.target.value }))} />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small mb-0">Precio</label>
                    <input className="form-control" type="number" step="0.01" value={hostingForm.precio} onChange={(e) => setHostingForm((p) => ({ ...p, precio: e.target.value }))} />
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    <button className="btn btn-primary w-100" type="submit">{hostingForm.id ? 'Actualizar' : 'Añadir'}</button>
                  </div>
                </form>
                {hostings.length ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Hosting</th>
                          <th>Características</th>
                          <th>Alta</th>
                          <th>Renovación</th>
                          <th>Precio</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {hostings.map((h) => (
                          <tr key={h.id}>
                            <td>{h.hosting}</td>
                            <td>{h.caracteristicas || '-'}</td>
                            <td>{h.fecha_alta || '-'}</td>
                            <td>{h.fecha_renovacion || '-'}</td>
                            <td>{h.precio ? `${h.precio} €` : '-'}</td>
                            <td className="text-end">
                              <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => editHosting(h)}>Editar</button>
                              <button className="btn btn-sm btn-outline-danger" onClick={() => deleteHosting(h.id)}>Eliminar</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <p>No hay hostings.</p>}
              </>
            )}

            {activeTab === 'Presupuestos' && (
              <>
                <h5>Presupuestos</h5>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted small">Manual o sincronizados con Dolibarr</span>
                  <button className="btn btn-outline-secondary btn-sm" disabled={syncingBudgets} onClick={syncBudgetsDolibarr}>
                    {syncingBudgets ? 'Sincronizando...' : 'Sincronizar Dolibarr'}
                  </button>
                </div>
                <div className="mb-3">
                  <button className="btn btn-primary btn-sm" onClick={() => navigate(`/presupuestos/nuevo?clientId=${id}`)}>
                    Nuevo presupuesto
                  </button>
                </div>
                {budgets.length ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Presupuesto</th>
                          <th>Fecha</th>
                          <th>Estado</th>
                          <th>Canal</th>
                          <th>Base</th>
                          <th>IVA</th>
                          <th>Total</th>
                          <th className="text-center" title="Visible en el área cliente">Área cliente</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedBudgets.map((b) => (
                          <tr key={b.id}>
                            <td>{b.presupuesto}</td>
                            <td>{formatDate(b.fecha)}</td>
                            <td>{b.estado}</td>
                            <td>{b.canal}</td>
                            <td>{formatCurrency(b.base_imponible)}</td>
                            <td>{formatCurrency(b.iva)}</td>
                            <td>{formatCurrency(b.total)}</td>
                            <td className="text-center">
                              <div className="form-check form-switch d-inline-flex justify-content-center m-0" title={b.visible_cliente ? 'Visible en el área cliente' : 'Oculto en el área cliente'}>
                                <input className="form-check-input" type="checkbox" role="switch" checked={b.visible_cliente === true} onChange={() => toggleBudgetVisibility(b)} aria-label="Visible en el área cliente" />
                              </div>
                            </td>
                            <td className="text-end">
                              <button type="button" className="btn btn-sm btn-outline-secondary me-2" title="Ver líneas" aria-label={`Ver líneas de presupuesto ${b.presupuesto || b.id}`} onClick={() => setLinesDocument({ document: b, kind: 'budgets' })}><BsEye /></button>
                              <BudgetActionsMenu budget={b} token={token} onRefresh={fetchBudgets} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="small text-muted">Página {budgetPage} de {totalBudgetPages} (total {budgets.length})</div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" disabled={budgetPage <= 1} onClick={() => setBudgetPage((p) => p - 1)}>Anterior</button>
                        <button className="btn btn-sm btn-outline-secondary" disabled={budgetPage >= totalBudgetPages} onClick={() => setBudgetPage((p) => p + 1)}>Siguiente</button>
                      </div>
                    </div>
                  </div>
                ) : <p>No hay presupuestos.</p>}
              </>
            )}

            {activeTab === 'Facturas' && (
              <>
                <h5>Facturas</h5>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted small">Sincronizadas con Dolibarr</span>
                  <button className="btn btn-outline-secondary btn-sm" disabled={syncingInvoices} onClick={syncInvoicesDolibarr}>
                    {syncingInvoices ? 'Sincronizando...' : 'Sincronizar facturas Dolibarr'}
                  </button>
                </div>
                <div className="mb-3">
                  <button className="btn btn-primary btn-sm" onClick={() => navigate(`/facturas/nueva?clientId=${id}`)}>
                    Nueva factura
                  </button>
                </div>
                {loadingInvoices ? (
                  <p>Cargando facturas...</p>
                ) : realInvoices.length ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Número</th>
                          <th>Fecha</th>
                          <th>Estado</th>
                          <th>Subtotal</th>
                          <th>IVA</th>
                          <th>Total</th>
                          <th className="text-center" title="Visible en el área cliente">Área cliente</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedInvoices.map((f) => (
                          <tr key={f.id}>
                            <td>{f.numero || '-'}</td>
                            <td>{formatDate(f.fecha)}</td>
                            <td>{f.estado || '-'}</td>
                            <td>{formatCurrency(f.subtotal)}</td>
                            <td>{formatCurrency(f.iva)}</td>
                            <td>{formatCurrency(f.total)}</td>
                            <td className="text-center">
                              <div className="form-check form-switch d-inline-flex justify-content-center m-0" title={f.visible_cliente !== false ? 'Visible en el área cliente' : 'Oculta en el área cliente'}>
                                <input className="form-check-input" type="checkbox" role="switch" checked={f.visible_cliente !== false} onChange={() => toggleInvoiceVisibility(f)} aria-label="Visible en el área cliente" />
                              </div>
                            </td>
                            <td className="text-end">
                              <button type="button" className="btn btn-sm btn-outline-secondary me-2" title="Ver líneas" aria-label={`Ver líneas de factura ${f.numero || f.id}`} onClick={() => setLinesDocument({ document: f, kind: 'invoices' })}><BsEye /></button>
                              <button
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => previewPdf(`/api/clients/invoices/${f.id}/${f.dolibarr_invoice_id ? 'dolibarr-pdf' : 'pdf'}`)}
                              >
                                Ver PDF
                              </button>
                              {f.dolibarr_invoice_id && (
                                <button
                                  className="btn btn-sm btn-outline-primary me-2"
                                  onClick={() => downloadFile(`/api/clients/invoices/${f.id}/dolibarr-pdf`, `${f.numero || 'factura'}.pdf`)}
                                >
                                  PDF Dolibarr
                                </button>
                              )}
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => downloadFile(`/api/clients/invoices/${f.id}/pdf`, `${f.numero || 'factura'}.pdf`)}
                              >
                                PDF
                              </button>
                              <button
                                className="btn btn-sm btn-outline-success me-2"
                                onClick={() => openWhatsappInvoiceModal(f)}
                              >
                                WhatsApp
                              </button>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => openEmailInvoiceModal(f)}
                              >
                                Email
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => navigate(`/facturas/${f.id}?clientId=${id}`, { state: { invoiceNavigation: { ids: invoices.filter((item) => !item.is_recurrent).map((item) => item.id), currentId: f.id, returnTo: `/clientes/${id}?tab=Facturas` } } })}
                              >
                                {f.dolibarr_invoice_id ? 'Ver' : 'Ver/Editar'}
                              </button>
                              {f.invoice_type === 'proforma' && !f.dolibarr_invoice_id && (
                                <button
                                  className="btn btn-sm btn-outline-success me-2"
                                  onClick={() => facturarProforma(f.id)}
                                >
                                  Facturar
                                </button>
                              )}
                              {!f.dolibarr_invoice_id && ['borrador', 'proforma'].includes(String(f.estado || '').toLowerCase()) && (
                                <button className="btn btn-sm btn-outline-danger" onClick={() => deleteInvoice(f.id)}>Eliminar</button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="small text-muted">Página {invoicePage} de {totalInvoicePages} (total {realInvoices.length})</div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" disabled={invoicePage <= 1} onClick={() => setInvoicePage((p) => p - 1)}>Anterior</button>
                        <button className="btn btn-sm btn-outline-secondary" disabled={invoicePage >= totalInvoicePages} onClick={() => setInvoicePage((p) => p + 1)}>Siguiente</button>
                      </div>
                    </div>
                  </div>
                ) : <p>No hay facturas.</p>}
              </>
            )}

            {activeTab === 'Facturas recurrentes' && (
              <>
                <h5>Facturas recurrentes</h5>
                <p className="text-muted small">Plantillas que generan facturas automáticamente. No son facturas fiscales.</p>
                <div className="mb-3">
                  <button className="btn btn-primary btn-sm" onClick={() => navigate(`/facturas/nueva?clientId=${id}`)}>
                    Nueva factura recurrente
                  </button>
                </div>
                {loadingInvoices ? (
                  <p>Cargando facturas...</p>
                ) : recurrentInvoices.length ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Número</th>
                          <th>Periodicidad</th>
                          <th>Próxima renovación</th>
                          <th>Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {recurrentInvoices.map((f) => (
                          <tr key={f.id}>
                            <td>{f.numero || f.serie || `#${f.id}`}</td>
                            <td>{formatRecurrence(f.recurrent_unit, f.recurrent_interval)}</td>
                            <td>{formatDate(f.recurrent_next_date)}</td>
                            <td>{formatCurrency(f.total)}</td>
                            <td className="text-end">
                              <button type="button" className="btn btn-sm btn-outline-secondary me-2" title="Ver líneas" aria-label={`Ver líneas de plantilla ${f.numero || f.id}`} onClick={() => setLinesDocument({ document: f, kind: 'invoices' })}><BsEye /></button>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => navigate(`/facturas/${f.id}?clientId=${id}`, { state: { invoiceNavigation: { ids: recurrentInvoices.map((item) => item.id), currentId: f.id, returnTo: `/clientes/${id}?tab=${encodeURIComponent('Facturas recurrentes')}` } } })}
                              >
                                Ver/Editar
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <p>Este cliente no tiene facturas recurrentes.</p>}
              </>
            )}

          </div>
        </div>
      )}
      {activeTab === 'Perfil IA' && (
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Perfil IA</h5>
              <button className="btn btn-sm btn-outline-primary" disabled={loadingProfile} onClick={regenerateProfile}>
                {loadingProfile ? 'Generando…' : (clientProfile ? 'Regenerar' : 'Generar perfil')}
              </button>
            </div>
            {loadingProfile ? (
              <p className="text-muted">Generando perfil con IA… (puede tardar unos segundos)</p>
            ) : clientProfile ? (
              <>
                <div className="row g-3">
                  <div className="col-12">
                    <div className="card bg-light"><div className="card-body">
                      <h6 className="card-title">Resumen</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.summary || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Contexto de negocio</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.business_context || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Proyectos</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.active_projects || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Resumen financiero</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.financial_summary || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Infraestructura</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.infrastructure || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Estilo de comunicaci&oacute;n</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.communication_style || 'No disponible'}</p>
                    </div></div>
                  </div>
                  <div className="col-md-6">
                    <div className="card bg-light h-100"><div className="card-body">
                      <h6 className="card-title">Temas pendientes</h6>
                      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{clientProfile.pending_items || 'No disponible'}</p>
                    </div></div>
                  </div>
                  {Array.isArray(clientProfile.key_topics) && clientProfile.key_topics.length > 0 && (
                    <div className="col-12">
                      <div className="card bg-light"><div className="card-body">
                        <h6 className="card-title">Temas clave</h6>
                        <div className="d-flex flex-wrap gap-1">
                          {clientProfile.key_topics.map((t, i) => (
                            <span key={i} className="badge bg-primary">{t}</span>
                          ))}
                        </div>
                      </div></div>
                    </div>
                  )}
                </div>
                <div className="text-muted small mt-3">
                  Actualizado: {clientProfile.updated_at ? new Date(clientProfile.updated_at).toLocaleString() : '-'} | Versi&oacute;n: {clientProfile.version || '-'} | Mensajes analizados: {clientProfile.message_count || 0}
                </div>
              </>
            ) : (
              <p className="text-muted">No hay perfil IA disponible para este cliente. Ejecuta &quot;Generar perfiles&quot; en Comunicaciones &gt; Configuraci&oacute;n.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientDetailPage;
